export default __webpack_public_path__ + "static/media/img4.9d274904.png";